import React, { useContext, useState } from 'react';
import { EditModeContext } from '../context/EditModeContext';
import clsx from 'clsx';

const EditModeToggle = () => {
  const {
    isEditMode,
    toggleEditMode,
    hasChanges,
    saveChanges,
    cancelChanges
  } = useContext(EditModeContext);

  const [isSaving, setIsSaving] = useState(false);

  const handleSave = async () => {
    setIsSaving(true);
    try {
      const success = await saveChanges();
      if (success) {
        // Optionally show success message
      }
    } finally {
      setIsSaving(false);
    }
  };

  return (
    <div className="flex items-center gap-2">
      <button
        onClick={toggleEditMode}
        className={clsx(
          'px-3 py-1.5 text-sm font-medium rounded-md',
          'transition-colors duration-200',
          isEditMode ? [
            'bg-blue-100 text-blue-700',
            'hover:bg-blue-200'
          ] : [
            'bg-white text-gray-700',
            'border border-gray-300',
            'hover:bg-gray-50'
          ]
        )}
      >
        {isEditMode ? 'Exit Edit Mode' : 'Edit Mode'}
      </button>

      {isEditMode && hasChanges && (
        <>
          <button
            onClick={handleSave}
            className={clsx(
              'px-3 py-1.5 text-sm font-medium rounded-md',
              'bg-blue-600 text-white',
              'hover:bg-blue-700',
              'transition-colors duration-200',
              'flex items-center gap-2',
              isSaving && 'opacity-75 cursor-not-allowed'
            )}
            disabled={isSaving}
          >
            {isSaving ? (
              <>
                <svg className="animate-spin h-4 w-4 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                  <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                  <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                </svg>
                <span>Saving...</span>
              </>
            ) : (
              'Save Changes'
            )}
          </button>
          <button
            onClick={cancelChanges}
            className={clsx(
              'px-3 py-1.5 text-sm font-medium rounded-md',
              'bg-white text-gray-700',
              'border border-gray-300',
              'hover:bg-gray-50',
              'transition-colors duration-200'
            )}
          >
            Cancel
          </button>
        </>
      )}
    </div>
  );
};

export default EditModeToggle;
